import HeaderContComponent from "../../../components/headerContactComponent/HeaderContComponent";
import { Button, Carousel, CloseButton, Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import "./HomeEditStyle.css";
import { auth, db, stg } from "../../../config/FirebaseConfig";
import {
  ref,
  uploadBytes,
  getDownloadURL,
  deleteObject,
} from "firebase/storage";
import {
  collection,
  getDocs,
  doc,
  setDoc,
  getDoc,
  addDoc,
  deleteDoc,
} from "firebase/firestore";
import FooterComponent from "../../../components/footerComponent/FooterComponent";
import { FaTrash } from "react-icons/fa";
import { MdEdit } from "react-icons/md";
import Swal from "sweetalert2";
import Loader from "../../../components/loader/Loader";
import { useNavigate } from "react-router-dom";
import HeaderAdminComponent from "../components/HeaderAdminComponent/HeaderAdminComponent";
import { onAuthStateChanged } from "firebase/auth";
import { ModalIndicouGanhou } from "../../../components/ModalIndicouGanhou/modalIndicouGanhou";
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { ColourfulText } from "../../../components/ColourfulText/ColourfulText";
import AppPromotionSection from "../../../components/AppDownload/AppDownload";
import FloatingNotification from "../../../components/FloatingNotification/FloatingNotification";

const SortableCard = ({
  id,
  card,
  editarCard,
  handleCardChange,
  deleteCard,
}) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <span
      ref={setNodeRef}
      style={style}
      className="plan-card"
      onClick={() => editarCard(card)}
    >
      <input
        onChange={(event) => handleCardChange(event, card)}
        style={{ display: "none" }}
        id={`card_${card.panel}_${card.card}`}
        type="file"
        className="form-control"
        accept="image/*"
      />
      <div className="drag-handle" {...attributes} {...listeners}>
        ⋮⋮
      </div>
      <div>
        <img alt="" src={card.photo} className="panel-card-img-edit" />
      </div>
      <div
        className="btn_edita_foto"
        onClick={(e) => {
          e.stopPropagation();
          editarCard(card);
        }}
      >
        <MdEdit className="icon-min" />
      </div>
      <div
        className="btn_delete_foto"
        onClick={(e) => {
          e.stopPropagation();
          deleteCard(card);
        }}
      >
        <FaTrash className="icon-min" />
      </div>
    </span>
  );
};

export default function HomePageEdit() {
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  const handleDragEnd = async (event, panel) => {
    const { active, over } = event;

    if (active.id !== over.id) {
      let items;
      let setItems;
      switch (panel) {
        case 1:
          items = panel1;
          setItems = setPanel1;
          break;
        case 2:
          items = panel2;
          setItems = setPanel2;
          break;
        case 3:
          items = panel3;
          setItems = setPanel3;
          break;
        case 4:
          items = panel4;
          setItems = setPanel4;
          break;
        default:
          return;
      }

      const oldIndex = items.findIndex((item) => item.id === active.id);
      const newIndex = items.findIndex((item) => item.id === over.id);

      const newItems = arrayMove(items, oldIndex, newIndex);
      setItems(newItems);

      // Persist the new order to Firestore
      try {
        const batch = [];
        newItems.forEach((item, index) => {
          const docRef = doc(db, "panels", item.id);
          batch.push(setDoc(docRef, { card: index + 1 }, { merge: true }));
        });
        await Promise.all(batch);
        console.log("Order updated successfully");
      } catch (error) {
        console.error("Error updating order:", error);
      }
    }
  };

  const navigate = useNavigate();
  const [index, setIndex] = useState(0);
  const [panel1, setPanel1] = useState([]);
  const [panel2, setPanel2] = useState([]);
  const [panel3, setPanel3] = useState([]);
  const [panel4, setPanel4] = useState([]);
  const [carousel, setCarousel] = useState([]);
  const [show, setShow] = useState(false);
  const [imagensSelecionadas, setImagensSelecionadas] = useState([
    { photo: null, panel: 1 },
    { photo: null, panel: 2 },
    { photo: null, panel: 3 },
    { photo: null, panel: 4 },
  ]);
  const [imagensSelecionadasMobile, setImagensSelecionadasMobile] = useState([
    { photoMobile: null, panel: 1 },
    { photoMobile: null, panel: 2 },
    { photoMobile: null, panel: 3 },
    { photoMobile: null, panel: 4 },
  ]);
  const [isLoading, setLoading] = useState(false);
  const [links, setLinks] = useState([]);
  const [campanhaIndicouGanhou, setCampanhaIndicouGanhou] = useState([]);
  const [showIndicouGanhouModal, setShowIndicouGanhouModal] = useState(false);
  const [currentPanel, setCurrentPanel] = useState(null);
  const [linksParceiros, setLinksParceiros] = useState([]);
  const [linksClientes, setLinksClientes] = useState([]);
  const [editingParceiro, setEditingParceiro] = useState({});
  const [editingCliente, setEditingCliente] = useState({});

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  const handleClose = () => setShow(false);

  const handleLinkCheckboxChange = (panel, checked) => {
    // Verifica se a campanha Indicou e Ganhou está ativa para este painel
    const campanhaAtiva = campanhaIndicouGanhou.find(
      (c) => c.panel === panel
    )?.enabled;

    if (campanhaAtiva && checked) {
      // Se a campanha estiver ativa e o usuário tentar habilitar o link, impede a ação
      Swal.fire({
        title: "Ação não permitida",
        text: "Não é possível habilitar link quando a Campanha Indicou e Ganhou está ativa.",
        icon: "warning",
        confirmButtonText: "Entendi",
      });
      return;
    }

    setLinks((prevLinks) =>
      prevLinks.map((link) =>
        link.panel === panel
          ? {
              ...link,
              linkEnabled: checked,
              linkUrl: checked ? link.linkUrl : "",
            }
          : link
      )
    );
  };

  const handleLinkUrlChange = (panel, url) => {
    setLinks((prevLinks) =>
      prevLinks.map((link) =>
        link.panel === panel ? { ...link, linkUrl: url } : link
      )
    );
  };

  const handleIndicouGanhouCheckboxChange = (panel, checked) => {
    if (checked) {
      // Se ativando a campanha, desabilitar o link automaticamente
      setLinks((prevLinks) =>
        prevLinks.map((link) =>
          link.panel === panel
            ? {
                ...link,
                linkEnabled: false,
                linkUrl: "",
              }
            : link
        )
      );
    }

    setCampanhaIndicouGanhou((prevCampanha) =>
      prevCampanha.map((campanha) =>
        campanha.panel === panel
          ? {
              ...campanha,
              enabled: checked,
            }
          : campanha
      )
    );
  };

  const handleParceiroUrlChange = (panel, url) => {
    setLinksParceiros((prevLinks) =>
      prevLinks.map((link) =>
        link.panel === panel ? { ...link, url: url } : link
      )
    );
  };

  const handleClienteUrlChange = (panel, url) => {
    setLinksClientes((prevLinks) =>
      prevLinks.map((link) =>
        link.panel === panel ? { ...link, url: url } : link
      )
    );
  };

  useEffect(() => {
    setLoading(true);
    const checkIfLoggedIn = () => {
      onAuthStateChanged(auth, (user) => {
        if (user) {
        } else {
          console.log("não logado");
          navigate("/login");
        }
      });
    };
    checkIfLoggedIn();
    const getPanels = async () => {
      const data = await getDocs(collection(db, "panels"));
      setPanel1(
        data.docs
          .map((doc) => ({ ...doc.data(), id: doc.id }))
          .filter((panel) => panel.panel === 1)
      );
      setPanel2(
        data.docs
          .map((doc) => ({ ...doc.data(), id: doc.id }))
          .filter((panel) => panel.panel === 2)
      );
      setPanel3(
        data.docs
          .map((doc) => ({ ...doc.data(), id: doc.id }))
          .filter((panel) => panel.panel === 3)
      );
      setPanel4(
        data.docs
          .map((doc) => ({ ...doc.data(), id: doc.id }))
          .filter((panel) => panel.panel === 4)
      );
    };

    const getCarousel = async () => {
      const carouselCollection = collection(db, "carousel");
      const data = await getDocs(carouselCollection);
      const carouselData = data.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      }));
      setCarousel(carouselData);
      const linksData = carouselData.map((item) => ({
        panel: item.panel,
        linkEnabled: !!item.link,
        linkUrl: item.link || "",
      }));
      setLinks(linksData);
      const campanhaData = carouselData.map((item) => ({
        panel: item.panel,
        enabled: !!item.campanhaIndicouGanhou,
      }));
      setCampanhaIndicouGanhou(campanhaData);
      const linksParceirosData = carouselData.map((item) => ({
        panel: item.panel,
        url: item.linkParceiro || "",
      }));
      setLinksParceiros(linksParceirosData);
      const linksClientesData = carouselData.map((item) => ({
        panel: item.panel,
        url: item.linkCliente || "",
      }));
      setLinksClientes(linksClientesData);
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    };

    getPanels();
    getCarousel();
  }, [navigate]);

  const handleImageClick = (id) => {
    const fileInput = document.getElementById(id);
    if (fileInput) {
      fileInput.click();
    }
  };

  const handleImageChange = (event, panel, display) => {
    console.log("handleImageChange => painel:", panel, "display:", display);

    const imagem = event.target.files[0];
    if (!imagem) return;

    const isMobile = display === "mobile";
    const updateArray = isMobile
      ? [...imagensSelecionadasMobile]
      : [...imagensSelecionadas];

    const index = panel - 1; // painel 1 está no index 0, etc.
    if (isMobile) {
      updateArray[index] = { photoMobile: imagem, panel };
      setImagensSelecionadasMobile(updateArray);
    } else {
      updateArray[index] = { photo: imagem, panel };
      setImagensSelecionadas(updateArray);
    }

    setCarousel((prevCarousel) =>
      prevCarousel.map((item) => {
        if (item.panel === panel) {
          return isMobile
            ? { ...item, photoMobile: URL.createObjectURL(imagem) }
            : { ...item, photo: URL.createObjectURL(imagem) };
        }
        return item;
      })
    );
  };

  const salvarCarousel = async () => {
    setLoading(true);
    const data = await getDocs(collection(db, "carousel"));
    const listaCarousel = data.docs.map((doc) => ({
      ...doc.data(),
      id: doc.id,
    }));

    imagensSelecionadas.forEach((element) => {
      if (element.photo !== null) {
        let carousel;
        for (let c of listaCarousel) {
          if (c.panel === parseInt(element.panel)) {
            carousel = c;
          }
        }

        if (
          carousel.photo !== null &&
          carousel.photo !== "" &&
          carousel.photo.indexOf("/assets/no-image.png") === -1
        ) {
          const fileRef = ref(stg, carousel.photo);

          deleteObject(fileRef)
            .then(() => {})
            .catch((error) => {
              console.error("Erro ao deletar o arquivo:", error);
            });
        }

        const imageRef = ref(stg, `${element.photo.name + carousel.id}`);
        uploadBytes(imageRef, element.photo)
          .then((resultado) => {
            getDownloadURL(resultado.ref)
              .then((url) => {
                let carouselObjToUpload = {
                  panel: carousel.panel,
                  photo: url,
                  insertDate: new Date(),
                };
                const carouselCollection = collection(db, "carousel");

                setDoc(
                  doc(carouselCollection, carousel.id),
                  carouselObjToUpload,
                  { merge: true }
                )
                  .then(async function (resultado) {})
                  .catch(function (error) {
                    console.error(
                      "Erro ao atualizar documento do carousel:",
                      error
                    );
                  });
              })
              .catch((error) => {
                console.error("Erro ao obter a URL:", error);
              });
          })
          .catch((error) => {
            console.error("Erro no upload:", error);
          });
      }
    });
    imagensSelecionadasMobile.forEach((element) => {
      if (element.photoMobile !== null) {
        let carousel;
        for (let c of listaCarousel) {
          if (c.panel === parseInt(element.panel)) {
            carousel = c;
          }
        }

        if (
          carousel.photoMobile !== null &&
          carousel.photoMobile !== "" &&
          carousel.photoMobile.indexOf("/assets/no-image-mobile.png") === -1
        ) {
          const fileRef = ref(stg, carousel.photoMobile);

          deleteObject(fileRef)
            .then(() => {})
            .catch((error) => {
              console.error("Erro ao deletar o arquivo:", error);
            });
        }

        const imageRef = ref(
          stg,
          `${element.photoMobile.name + "mobile" + carousel.id}`
        );
        uploadBytes(imageRef, element.photoMobile)
          .then((resultado) => {
            getDownloadURL(resultado.ref)
              .then((url) => {
                let carouselObjToUpload = {
                  panel: carousel.panel,
                  photoMobile: url,
                  insertDate: new Date(),
                };
                const carouselCollection = collection(db, "carousel");

                setDoc(
                  doc(carouselCollection, carousel.id),
                  carouselObjToUpload,
                  { merge: true }
                )
                  .then(async function (resultado) {})
                  .catch(function (error) {
                    console.error(
                      "Erro ao atualizar documento do carousel:",
                      error
                    );
                  });
              })
              .catch((error) => {
                console.error("Erro ao obter a URL:", error);
              });
          })
          .catch((error) => {
            console.error("Erro no upload:", error);
          });
      }
    });
    // Save links
    links.forEach((linkItem) => {
      const carouselDoc = listaCarousel.find((c) => c.panel === linkItem.panel);
      if (carouselDoc) {
        const linkValue = linkItem.linkEnabled ? linkItem.linkUrl : "";
        setDoc(
          doc(db, "carousel", carouselDoc.id),
          { link: linkValue },
          { merge: true }
        ).catch((error) => {
          console.error("Erro ao atualizar link do carousel:", error);
        });
      }
    });
    // Save campanhaIndicouGanhou
    campanhaIndicouGanhou.forEach((campanhaItem) => {
      const carouselDoc = listaCarousel.find(
        (c) => c.panel === campanhaItem.panel
      );
      if (carouselDoc) {
        setDoc(
          doc(db, "carousel", carouselDoc.id),
          { campanhaIndicouGanhou: campanhaItem.enabled },
          { merge: true }
        ).catch((error) => {
          console.error(
            "Erro ao atualizar campanhaIndicouGanhou do carousel:",
            error
          );
        });
      }
    });
    // Save linksParceiros
    linksParceiros.forEach((linkItem) => {
      const carouselDoc = listaCarousel.find((c) => c.panel === linkItem.panel);
      if (carouselDoc) {
        setDoc(
          doc(db, "carousel", carouselDoc.id),
          { linkParceiro: linkItem.url },
          { merge: true }
        ).catch((error) => {
          console.error("Erro ao atualizar linkParceiro do carousel:", error);
        });
      }
    });
    // Save linksClientes
    linksClientes.forEach((linkItem) => {
      const carouselDoc = listaCarousel.find((c) => c.panel === linkItem.panel);
      if (carouselDoc) {
        setDoc(
          doc(db, "carousel", carouselDoc.id),
          { linkCliente: linkItem.url },
          { merge: true }
        ).catch((error) => {
          console.error("Erro ao atualizar linkCliente do carousel:", error);
        });
      }
    });

    setLoading(false);
    await Swal.fire({
      title: "Sucesso!",
      text: "Alterações salvas com sucesso!",
      icon: "success",
      confirmButtonText: "Ok",
    });
    setShow(false);
  };

  const deletarImg = async (idImage, idInput, display) => {
    const imagemElement = document.getElementById(idImage);
    if (imagemElement) {
      if (
        imagemElement.src !== null &&
        imagemElement.src !== "" &&
        imagemElement.src.indexOf("/assets/no-image.png") === -1
      ) {
        const resultado = await Swal.fire({
          title: "Atenção",
          text: "Você tem certeza de que deseja deletar a imagem (após deletar a imagem não poderá mais ser recuperada)?",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Sim",
          cancelButtonText: "Cancelar",
        });

        if (resultado.isConfirmed) {
          setLoading(true);
          const panel = idImage.split("_")[1];

          const input = document.getElementById(idInput);
          if (input) {
            input.value = "";
          }

          setCarousel((prevCarousel) =>
            prevCarousel.map((item) => {
              if (item.panel === parseInt(panel)) {
                if (display === "desktop")
                  return { ...item, photo: "./assets/no-image.png" };
                else if (display === "mobile")
                  return {
                    ...item,
                    photoMobile: "./assets/no-image-mobile.png",
                  };
              }
              return item;
            })
          );

          const carouselItem = carousel.find(
            (item) => item.panel === parseInt(panel)
          );
          if (display === "desktop")
            if (carouselItem && carouselItem.photo) {
              const fileRef = ref(stg, carouselItem.photo);

              try {
                await deleteObject(fileRef);
                console.log("Imagem deletada do storage.");
              } catch (error) {
                console.error("Erro ao deletar a imagem do storage:", error);
              }
            } else if (display === "mobile")
              if (carouselItem && carouselItem.photoMobile) {
                const fileRef = ref(stg, carouselItem.photoMobile);
                try {
                  await deleteObject(fileRef);
                  console.log("Imagem deletada do storage.");
                } catch (error) {
                  console.error("Erro ao deletar a imagem do storage:", error);
                }
              }

          const carouselCollection = collection(db, "carousel");
          const querySnapshot = await getDocs(carouselCollection);
          querySnapshot.forEach(async (doc) => {
            const data = doc.data();
            if (data.panel === parseInt(panel)) {
              try {
                if (display === "desktop") {
                  await setDoc(
                    doc.ref,
                    { photo: "./assets/no-image.png" },
                    { merge: true }
                  );
                  setLoading(false);
                  Swal.fire("Deletado com sucesso!");
                } else if (display === "mobile") {
                  await setDoc(
                    doc.ref,
                    { photoMobile: "./assets/no-image-mobile.png" },
                    { merge: true }
                  );
                  setLoading(false);
                  Swal.fire("Deletado com sucesso!");
                }
              } catch (error) {
                console.error(
                  "Erro ao atualizar o atributo photo na collection do Firebase:",
                  error
                );
              }
            }
          });
        }
      }
    }
  };

  const editarCard = (card) => {
    console.log("card", "card_" + card.panel + card.card);
    const fileInput = document.getElementById(
      "card_" + card.panel + "_" + card.card
    );
    if (fileInput) {
      fileInput.click();
    }
  };

  const handleCardChange = async (event, card) => {
    const imagem = event.target.files[0];
    if (imagem) {
      switch (card.panel) {
        case 1:
          await salvarCard(card, imagem).then(() => {
            setPanel1((prevPanel1) =>
              prevPanel1.map((item) => {
                if (item.panel === card.panel) {
                  if (item.card === card.card)
                    return { ...item, photo: URL.createObjectURL(imagem) };
                }
                return item;
              })
            );
          });
          break;
        case 2:
          await salvarCard(card, imagem).then(() => {
            setPanel2((prevPanel2) =>
              prevPanel2.map((item) => {
                if (item.panel === card.panel) {
                  if (item.card === card.card)
                    return { ...item, photo: URL.createObjectURL(imagem) };
                }
                return item;
              })
            );
          });
          break;
        case 3:
          await salvarCard(card, imagem).then(() => {
            setPanel3((prevPanel3) =>
              prevPanel3.map((item) => {
                if (item.panel === card.panel) {
                  if (item.card === card.card)
                    return { ...item, photo: URL.createObjectURL(imagem) };
                }
                return item;
              })
            );
          });
          break;
        case 4:
          await salvarCard(card, imagem).then(() => {
            setPanel4((prevPanel4) =>
              prevPanel4.map((item) => {
                if (item.panel === card.panel) {
                  if (item.card === card.card)
                    return { ...item, photo: URL.createObjectURL(imagem) };
                }
                return item;
              })
            );
          });
          break;
        default:
          break;
      }
    }
  };

  const addNewCard = async (panel) => {
    setLoading(true);
    try {
      const panelsCollection = collection(db, "panels");
      let existingCards = [];
      switch (panel) {
        case 1:
          existingCards = panel1;
          break;
        case 2:
          existingCards = panel2;
          break;
        case 3:
          existingCards = panel3;
          break;
        case 4:
          existingCards = panel4;
          break;
        default:
          break;
      }
      if (existingCards.length >= 4) {
        setLoading(false);
        await Swal.fire({
          title: "Limite atingido",
          text: "Não é possível adicionar mais de 4 cards por painel.",
          icon: "warning",
          confirmButtonText: "Ok",
        });
        return;
      }
      const nextCardNumber =
        existingCards.length > 0
          ? Math.max(...existingCards.map((card) => card.card)) + 1
          : 1;

      const newCard = {
        panel: panel,
        card: nextCardNumber,
        photo: "./assets/no-image.png",
        insertDate: new Date(),
      };

      const docRef = await addDoc(panelsCollection, newCard);
      console.log("Novo card adicionado com ID:", docRef.id);

      // Atualizar o estado local
      const updatedCard = { ...newCard, id: docRef.id };
      switch (panel) {
        case 1:
          setPanel1([...panel1, updatedCard]);
          break;
        case 2:
          setPanel2([...panel2, updatedCard]);
          break;
        case 3:
          setPanel3([...panel3, updatedCard]);
          break;
        case 4:
          setPanel4([...panel4, updatedCard]);
          break;
        default:
          break;
      }

      setLoading(false);
      await Swal.fire({
        title: "Sucesso!",
        text: "Novo card adicionado com sucesso!",
        icon: "success",
        confirmButtonText: "Ok",
      });
    } catch (error) {
      console.error("Erro ao adicionar novo card:", error);
      setLoading(false);
      await Swal.fire({
        title: "Erro!",
        text: "Erro ao adicionar novo card.",
        icon: "error",
        confirmButtonText: "Ok",
      });
    }
  };

  const salvarCard = async (card, imagem) => {
    setLoading(true);
    const panelsCollection = collection(db, "panels");
    const panel = await getDoc(doc(db, "panels", card.id));
    if (panel.exists()) {
      if (card.photo !== null && card.photo !== "") {
        const fileRef = ref(stg, card.photo);
        console.log(card);
        deleteObject(fileRef)
          .then(() => {})
          .catch((error) => {
            console.error("Erro ao deletar o arquivo:", error);
          });
      }

      const imageRef = ref(stg, `${imagem.name + card.id}`);
      uploadBytes(imageRef, imagem)
        .then((resultado) => {
          getDownloadURL(resultado.ref)
            .then((url) => {
              let panelObjToUpload = {
                photo: url,
                insertDate: new Date(),
              };

              setDoc(doc(panelsCollection, card.id), panelObjToUpload, {
                merge: true,
              })
                .then(async function (resultado) {
                  setLoading(false);
                  await Swal.fire({
                    title: "Sucesso!",
                    text: "Imagem Cadastrada/Alterada com sucesso!",
                    icon: "success",
                    confirmButtonText: "Ok",
                  });
                  setShow(false);
                })
                .catch(function (error) {
                  console.error("Erro ao atualizar documento do panel:", error);
                });
            })
            .catch((error) => {
              console.error("Erro ao obter a URL:", error);
            });
        })
        .catch((error) => {
          console.error("Erro no upload:", error);
        });
    }
  };

  const deleteCard = async (card) => {
    const result = await Swal.fire({
      title: "Atenção",
      text: "Você tem certeza de que deseja deletar este card? Esta ação não pode ser desfeita.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim, deletar",
      cancelButtonText: "Cancelar",
    });

    if (result.isConfirmed) {
      setLoading(true);
      try {
        // Delete image from storage if exists
        if (card.photo && card.photo !== "./assets/no-image.png") {
          const fileRef = ref(stg, card.photo);
          await deleteObject(fileRef);
        }

        // Delete document from Firestore
        await deleteDoc(doc(db, "panels", card.id));

        // Update local state
        switch (card.panel) {
          case 1:
            setPanel1(panel1.filter((c) => c.id !== card.id));
            break;
          case 2:
            setPanel2(panel2.filter((c) => c.id !== card.id));
            break;
          case 3:
            setPanel3(panel3.filter((c) => c.id !== card.id));
            break;
          case 4:
            setPanel4(panel4.filter((c) => c.id !== card.id));
            break;
          default:
            break;
        }

        setLoading(false);
        await Swal.fire({
          title: "Sucesso!",
          text: "Card deletado com sucesso!",
          icon: "success",
          confirmButtonText: "Ok",
        });
      } catch (error) {
        console.error("Erro ao deletar card:", error);
        setLoading(false);
        await Swal.fire({
          title: "Erro!",
          text: "Erro ao deletar card.",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
    }
  };

  return (
    <div>
      {isLoading && <Loader />}
      <HeaderContComponent />
      <HeaderAdminComponent />
      <Carousel
        style={{ marginTop: 50, backgroundColor: "#0a0a0a", width: "100%" }}
        activeIndex={index}
        onSelect={handleSelect}
      >
        {carousel.map((banner) => (
          <Carousel.Item
            key={banner.id}
            interval={7000}
            onClick={() => setShow(true)}
            style={{
              cursor: "pointer",
            }}
          >
            <img
              alt=""
              src={banner.photo}
              className="responsive-image desktop"
            />
            <img
              alt=""
              src={banner.photoMobile}
              className="responsive-image mobile"
            />
          </Carousel.Item>
        ))}
      </Carousel>
      <div className="content">
        <div className="content-sub">
          <div className="plan-container">
            <div className="plan-title">
              PLANOS{" "}
              <ColourfulText
                text="EXTRAORDINÁRIOS"
                gradient="linear-gradient(270deg, #e32285 28.23%, #9747ff 79.08%)"
              />{" "}
              PARA VOCÊ
            </div>
            <div className="retangle-line"></div>
            <Button
              className="btn-site-primary"
              onClick={() => addNewCard(1)}
              style={{ marginBottom: "10px", marginTop: "20px" }}
            >
              Adicionar Novo Card
            </Button>
            <div className="plan-cards">
              <DndContext
                sensors={sensors}
                onDragEnd={(event) => handleDragEnd(event, 1)}
              >
                <SortableContext
                  items={panel1.map((card) => card.id)}
                  strategy={verticalListSortingStrategy}
                >
                  {panel1.map((card) => (
                    <SortableCard
                      key={card.id}
                      id={card.id}
                      card={card}
                      editarCard={editarCard}
                      handleCardChange={handleCardChange}
                      deleteCard={deleteCard}
                      
                    />
                  ))}
                </SortableContext>
              </DndContext>
            </div>
          </div>
          <div className="plan-container">
            <div className="plan-title">
              CONFIRA{" "}
              <ColourfulText
                text="SUPERLANÇAMENTOS"
                gradient="linear-gradient(270deg, #e32285 28.23%, #9747ff 79.08%)"
              />{" "}
              AQUI
            </div>
            <div className="retangle-line"></div>
            <Button
              className="btn-site-primary"
              onClick={() => addNewCard(2)}
              style={{ marginBottom: "10px", marginTop: "20px" }}
            >
              Adicionar Novo Card
            </Button>
            <div className="plan-cards">
              <DndContext
                sensors={sensors}
                onDragEnd={(event) => handleDragEnd(event, 2)}
              >
                <SortableContext
                  items={panel2.map((card) => card.id)}
                  strategy={verticalListSortingStrategy}
                >
                  {panel2.map((card) => (
                    <SortableCard
                      key={card.id}
                      id={card.id}
                      card={card}
                      editarCard={editarCard}
                      handleCardChange={handleCardChange}
                      deleteCard={deleteCard}
                    />
                  ))}
                </SortableContext>
              </DndContext>
            </div>
          </div>
          <div className="plan-container">
            <div className="plan-title">NOSSAS </div>
            <div className="plan-title">
              <ColourfulText
                text="VANTAGENS"
                gradient="linear-gradient(270deg, #29abe3 28.23%, #f9b041 79.08%)"
              />
            </div>
            <div className="retangle-line2"></div>
            <Button
              className="btn-site-primary"
              onClick={() => addNewCard(3)}
              style={{ marginBottom: "10px", marginTop: "20px" }}
            >
              Adicionar Novo Card
            </Button>
            <div className="plan-cards">
              <DndContext
                sensors={sensors}
                onDragEnd={(event) => handleDragEnd(event, 3)}
              >
                <SortableContext
                  items={panel3.map((card) => card.id)}
                  strategy={verticalListSortingStrategy}
                >
                  {panel3.map((card) => (
                    <SortableCard
                      key={card.id}
                      id={card.id}
                      card={card}
                      editarCard={editarCard}
                      handleCardChange={handleCardChange}
                      deleteCard={deleteCard}
                    />
                  ))}
                </SortableContext>
              </DndContext>
            </div>
          </div>
          <div id="app">
            <AppPromotionSection />
          </div>
          <FooterComponent />
          <FloatingNotification />
        </div>
      </div>
      <div className="bg-1"></div>
      <div className="bg-2"></div>
      <div className="bg-3"></div>
      <div className="bg-4"></div>
      <div className="bg-5"></div>

      <ModalIndicouGanhou
        show={showIndicouGanhouModal}
        onHide={() => setShowIndicouGanhouModal(false)}
        currentPanel={currentPanel}
      />

      <Modal
        show={show}
        onHide={() => setShow(false)}
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
        id="main-modal"
      >
        <Modal.Header>
          <Modal.Title id="example-custom-modal-styling-title">
            Alterar Imagens do Banner
          </Modal.Title>
          <CloseButton
            style={{ backgroundColor: "#ff0000" }}
            onClick={() => setShow(false)}
          />
        </Modal.Header>
        <Modal.Body>
          {show && ( // Renderiza o conteúdo apenas quando o modal estiver aberto
            <div>
              <h5>Desktop</h5>
              <span className="text-muted ">
                *Tamanho obrigatório: 2000px X 540px
              </span>
              <div className="col col-md-12 col-12">
                <div className="form-group">
                  <div className="row">
                    {carousel.map((item) => {
                      const linkItem = links.find(
                        (l) => l.panel === item.panel
                      );
                      return (
                        <div className="col-md-3 col-3" key={item.id}>
                          <input
                            onChange={(event) =>
                              handleImageChange(event, item.panel, "desktop")
                            }
                            style={{ display: "none" }}
                            id={`foto_banner_${item.panel}_desktop`}
                            type="file"
                            className="form-control"
                            accept="image/*"
                          />
                          <button
                            className="btn_apaga_foto"
                            onClick={() => {
                              deletarImg(
                                `carouselPanel_${item.panel}_desktop`,
                                `foto_banner_${item.panel}_desktop`,
                                "desktop"
                              );
                            }}
                          >
                            <FaTrash className="icon" />
                          </button>
                          <img
                            id={`carouselPanel_${item.panel}_desktop`}
                            alt=""
                            src={item.photo || "./assets/no-image.png"}
                            className="carregar_imagem"
                            onClick={() =>
                              handleImageClick(
                                `foto_banner_${item.panel}_desktop`
                              )
                            }
                          />

                          <div className="mt-2">
                            {(() => {
                              const campanhaAtiva = campanhaIndicouGanhou.find(
                                (c) => c.panel === item.panel
                              )?.enabled;

                              return (
                                <label
                                  style={{
                                    fontStyle: campanhaAtiva
                                      ? "italic"
                                      : "normal",
                                    color: campanhaAtiva ? "gray" : "inherit",
                                    opacity: campanhaAtiva ? 0.6 : 1,
                                  }}
                                >
                                  <input
                                    type="checkbox"
                                    style={{ marginRight: "10px" }}
                                    checked={linkItem?.linkEnabled || false}
                                    disabled={campanhaAtiva}
                                    onChange={(e) =>
                                      handleLinkCheckboxChange(
                                        item.panel,
                                        e.target.checked
                                      )
                                    }
                                  />
                                  Habilitar link
                                  {campanhaAtiva && (
                                    <span
                                      style={{
                                        fontSize: "0.8em",
                                        color: "#dc3545",
                                        marginLeft: "10px",
                                      }}
                                    >
                                      (Desabilitado - Campanha ativa)
                                    </span>
                                  )}
                                </label>
                              );
                            })()}
                            {linkItem?.linkEnabled && (
                              <input
                                type="url"
                                placeholder="Digite a URL"
                                value={linkItem.linkUrl}
                                onChange={(e) =>
                                  handleLinkUrlChange(
                                    item.panel,
                                    e.target.value
                                  )
                                }
                                className="form-control mt-3"
                              />
                            )}
                          </div>
                          <div className="mt-2">
                            {(() => {
                              const campanhaAtiva = campanhaIndicouGanhou.find(
                                (c) => c.panel === item.panel
                              )?.enabled;
                              return (
                                <label>
                                  <input
                                    type="checkbox"
                                    style={{ marginRight: "10px" }}
                                    checked={
                                      campanhaIndicouGanhou.find(
                                        (c) => c.panel === item.panel
                                      )?.enabled || false
                                    }
                                    onChange={(e) =>
                                      handleIndicouGanhouCheckboxChange(
                                        item.panel,
                                        e.target.checked
                                      )
                                    }
                                  />
                                  Campanha Indicou e Ganhou
                                  {campanhaAtiva && (
                                    <>
                                      <div className="mt-3">
                                        <label className="form-label fw-bold">
                                          Link do Parceiro:
                                        </label>
                                        <input
                                          type="url"
                                          placeholder="Digite a URL do Parceiro"
                                          value={
                                            linksParceiros.find(
                                              (l) => l.panel === item.panel
                                            )?.url || ""
                                          }
                                          onChange={(e) =>
                                            handleParceiroUrlChange(
                                              item.panel,
                                              e.target.value
                                            )
                                          }
                                          className="form-control"
                                        />
                                      </div>
                                      <div className="mt-3">
                                        <label className="form-label fw-bold">
                                          Link do Cliente:
                                        </label>
                                        <input
                                          type="url"
                                          placeholder="Digite a URL do Cliente"
                                          value={
                                            linksClientes.find(
                                              (l) => l.panel === item.panel
                                            )?.url || ""
                                          }
                                          onChange={(e) =>
                                            handleClienteUrlChange(
                                              item.panel,
                                              e.target.value
                                            )
                                          }
                                          className="form-control"
                                        />
                                      </div>
                                    </>
                                  )}
                                </label>
                              );
                            })()}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>

                <br />
              </div>
              <h5 className="mt-5">Mobile</h5>
              <div className="col col-md-12 col-12">
                <div className="form-group">
                  <div className="row">
                    {carousel.map((item) => {
                      const linkItem = links.find(
                        (l) => l.panel === item.panel
                      );
                      return (
                        <div className="col-md-3 col-3" key={item.id}>
                          <input
                            onChange={(event) =>
                              handleImageChange(event, item.panel, "mobile")
                            }
                            style={{ display: "none" }}
                            id={`foto_banner_mobile_${item.panel}_mobile`}
                            type="file"
                            className="form-control"
                            accept="image/*"
                          />
                          <button
                            className="btn_apaga_foto"
                            onClick={() => {
                              deletarImg(
                                `carouselPanel_${item.panel}_mobile`,
                                `foto_banner_mobile_${item.panel}_mobile`,
                                "mobile"
                              );
                            }}
                          >
                            <FaTrash className="icon" />
                          </button>
                          <img
                            id={`carouselPanel_${item.panel}_mobile`}
                            alt=""
                            src={item.photoMobile || "./assets/no-image.png"}
                            className="carregar_imagem"
                            onClick={() =>
                              handleImageClick(
                                `foto_banner_mobile_${item.panel}_mobile`
                              )
                            }
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleClose}>
            Fechar
          </Button>
          <Button className="btn-site-primary" onClick={salvarCarousel}>
            Salvar Alterações
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
